<template>
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">{{ label }}</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            v-model="proxyValue"
            :required="required"
            :placeholder="placeholder"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalInputField',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    proxyValue: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('update:value', newVal)
      },
    },
  }
}
</script>



// WEBPACK FOOTER //
// HorizontalInputField.vue?28329198